import React = require('react');
import { AuthenticationService } from '~src/authentication/services/AuthenticationService';
import { Location } from '~src/common/react/Location';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { CommonErrorCode } from '~src/ts/helpers/ErrorCodes';
import { SiteSwitchService } from '~src/ts/siteManagement/services/SiteSwitchService';

import { LoginPage } from './LoginPage';
import { UsernameAndPasswordLoginProps } from './UsernameAndPasswordLogin';
import { UsernameAndPasswordLoginForm } from './UsernameAndPasswordLoginForm';

export function ExternalUsernameAndPasswordLogin(props: UsernameAndPasswordLoginProps) {

  function handleExternalAuthErrors(error: IError): Promise<void> {
    if (error.code !== CommonErrorCode.RedirectToOtherPod) {
      return Promise.resolve();
    }

    let redirectUrl = props.signinQueryParams.externalRedirect;

    if (!redirectUrl && props.signinQueryParams.redirect) {
      redirectUrl = '/#' + props.signinQueryParams.redirect;
    }
    if (!redirectUrl && AuthenticationService.isSigninToSpecificSite(props.signinQueryParams)) {
      redirectUrl = SiteSwitchService.getSiteUrlFragment(AuthenticationService.getSiteName(props.signinQueryParams));
    }
    if (!redirectUrl) {
      redirectUrl = '/' + Location.instance.hash();
    }
    getSessionManagementServiceInstance().redirectToOtherPod(error, redirectUrl);

    // We take control and redirect out to the correct pod, instead of sticking with the login form.
    return Promise.reject();
  }

  return <LoginPage>
    <UsernameAndPasswordLoginForm {...props} onError={handleExternalAuthErrors} />
  </LoginPage>;
}
